/**
 * //////////////////////////////////////////
 * SAGA WATCHERS (サガ・ウォッチャー)
 * --------------------
 * actions.jsからのすべてのアクションは、ここで読み込まれてからreducerに送られます。
 * イベントタイプが一致した場合、下記の第2パラメータの関数が呼び出され、任意のアクションデータを使用することができます。
 * ////////////////////////////////////////////
 */
import {takeLeading} from "redux-saga/effects";
import {transferApproveGet, transferApproveSend} from "./sagas";
import types from "./types";

export function* fetchApproveTransferRequest() {
    yield takeLeading(types.APPROVE_TRANSFER_REQUEST, transferApproveGet)
    yield takeLeading(types.SEND_APPROVE_TRANSFER_REQUEST, transferApproveSend)
}
